import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentDetails_ContentAssetReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsContentAssetReferenceFragment.generated'
export type YiCourseModuleDownload_ContentFragmentFragment = {
  __typename?: 'Content'
  yiCourseModuleDownload?: Array<{
    __typename?: 'ContentAssetReference'
    id?: string | null
    asset?: {
      __typename?: 'Asset'
      id?: string | null
      mimeType?: string | null
      fileSize?: number | null
      originalFileName?: string | null
      renderUrl?: string | null
      contentAssetReference?: {
        __typename?: 'ContentAssetReference'
        assetsId?: string | null
      } | null
    } | null
  } | null> | null
}

export const YiCourseModuleDownload_ContentFragmentFragmentDoc = gql`
  fragment YICourseModuleDownload_ContentFragment on Content {
    yiCourseModuleDownload: contentAssetReferences(
      contentAssetReferences: { type: "yi-course-module-download" }
    ) {
      ...ContentDetails_ContentAssetReferenceFragment
    }
  }
  ${ContentDetails_ContentAssetReferenceFragmentFragmentDoc}
`
